import {useLocalStorage} from '@wallaby-ui/core';
import {DEFAULT_PAGE_SIZE, getDefaultMTOptions, MaterialTableWrapper, TableSorting, getTableMaxHeight} from '@wallaby-ui/document';
import * as React from 'react';

import {BasicMeasuresRowType, FiltersData} from './departmenttypes';
import {useDepartmentBasicMeasuresTableColumns} from './useDepartmentBasicMeasuresTableColumns';

type DepartmentReportBasicMeasuresTableProps = {
  data: BasicMeasuresRowType | undefined;
  isLoading: boolean;
  filters: FiltersData;
  sorting: TableSorting;
  onSortingChange: (sorting: TableSorting) => void;
  storageIdPrefix: string;
};

export const DepartmentReportBasicMeasuresTable: React.FC<DepartmentReportBasicMeasuresTableProps> = ({
  data,
  isLoading,
  filters,
  sorting,
  onSortingChange,
  storageIdPrefix,
}) => {
  const [defaultTableScroll, setDefaultTableScroll] = useLocalStorage(`${storageIdPrefix}.tableScroll`, 0);
  const columns = useDepartmentBasicMeasuresTableColumns(sorting, filters.report);

  const handleOrderChange = (colIndex: number, direction: 'asc' | 'desc') => {
    const columnId = columns[colIndex].field as string;
    onSortingChange({
      field: columnId,
      direction,
    });
  };

  return (
    <MaterialTableWrapper
      style={{maxHeight: '100%'}}
      defaultScroll={{to: defaultTableScroll}}
      onScroll={(event) => setDefaultTableScroll((event.target as HTMLDivElement).scrollTop)}
      singleLineColumnLabels
      options={{
        ...getDefaultMTOptions(DEFAULT_PAGE_SIZE),
        paging: false,
      }}
      variant='big'
      useMaxHeight
      columns={columns}
      data={data ? [data] : []}
      isLoading={isLoading}
      totalCount={data ? 1 : 0}
      onOrderChange={handleOrderChange}
      controlledSort={sorting}
    />
  );
};
